module.exports = __webpack_public_path__ + "static/media/icon_search.d7dd3d26.svg";